import { render, staticRenderFns } from "./EmailTemplateModal.vue?vue&type=template&id=783be740&scoped=true&"
import script from "./EmailTemplateModal.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateModal.vue?vue&type=style&index=0&id=783be740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783be740",
  null
  
)

export default component.exports